<template>
  <DropdownLayout
    :id="id"
    :label="label"
    :message="message"
  >
    <select
      :id="id"
      v-model="selectedValue"
      :name="name"
      :disabled="disabled"
      class="dependentdropdown__field-select"
      @change="onChange($event)"
    >
      <option
        v-if="placeholder && placeholder !== ''"
        :value="value && -1"
      >
        {{ placeholder }}
      </option>
      <template v-if="!groupOption">
        <template 
          v-if="options.length && (options[0])">
          <option
            v-for="(option, i) in options"
            :key="i"
            :value="option.value"
            v-bind="option.attributes && option.attributes.length ? option.attributes[0] : null"
          >
            {{ option.text }}
          </option>
        </template>
        <template v-else>
          <option
            v-for="(option, i) in options"
            :key="i"
            :value="option[keyValue]"
            v-bind="option.attributes && option.attributes.length ? option.attributes[0] : null"
          >
            {{ option[keyLabel] }}
          </option>
        </template>
      </template>
      <template v-if="groupOption">
        <optgroup   
          v-for="(option, i) in options"
          :key="i" 
          :label="option.name"
        >
          <option
            v-for="(childrenOption, j) in option[groupOptionValue]"
            :key="j"
            :value="childrenOption[keyValue]"
          >
            {{ childrenOption[keyLabel] }}
          </option>
        </optgroup>
      </template>
    </select>
  </DropdownLayout>
</template>
<script>
  import DropdownLayout from './DropdownLayout.vue';
  export default {
    name: 'Dropdown',
    components: {
      DropdownLayout,
    },
    props: {
      groupOption: {
        type: Boolean,
        default: false,
      },
      groupOptionLabel: {
        type: String,
        default: null,
      },
      groupOptionValue: {
        type: String,
        default: null,
      },
      keyValue: {
        type: String,
        default: 'value'
      },
      keyLabel: {
        type: String,
        default: 'text'
      },
      id: {
        type: String,
        required: true,
      },
      name: {
        type: String,
        required: true,
      },
      label: {
        type: String,
        default: null,
      },
      message: {
        type: String,
        default: null,
      },
      value: {
        type: [String, Number],
        default: 0,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: '',
      },
      options: {
        type: Array,
        required: true,
      },
    },
    computed: {
      selectedValue: {
        get() {
          return this.value;
        },
        set() {},
      },
    },
    methods: {
      onChange(e) {
        this.$emit('related-dropdown-change', e.target.value);
      },
    },
  };
</script>

<style lang="scss">
.dependentdropdown {
  &--disabled {
    .dependentdropdown__field-svg {
      fill: $color-neutral-40;
    }

    .dependentdropdown__field-select {
      box-shadow: inset 0 0 0 1px $color-neutral-40;
    }
  }

  &__field {
    display: flex;
    flex-direction: column;
    padding: 0 0 20px;

    &-layout {
      position: relative;
    }

    &-icon {
      background: $white;
      display: inline-flex;
      fill: $color-select-arrow;
      height: 100%;
      padding: 0 5px;
      pointer-events: none;
      position: absolute;
      right: 0px;
      width: $height-select-arrow;
    }

    &-svg {
      display: block;
      height: 100%;
      width: 100%;
    }

    &-select {
      appearance: none;
      background-color: transparent;
      border: 0;
      border-radius: $border-radius-select;
      box-shadow: $boxshadow-select;
      color: $color-select;
      display: block;
      font-size: 100%;
      height: $height-select;
      moz-appearance: none;
      outline: none;
      padding: 0 15px;
      position: relative;
      text-transform: capitalize;
      transition: $transition-link;
      webkit-appearance: none;
      width: calc(100% - 30px);

      &::-ms-expand {
        display: none;
      }
      &:focus {
        box-shadow: $boxshadow-select-focus;
      }

    }
  }
}
</style>
